import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/landing2.png'


const _withScopeId = n => (_pushScopeId("data-v-da034eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "centerIntro"
}
const _hoisted_2 = { class: "intro" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "btn loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif",
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.isEnable)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "btn disabled",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
              }, "PLAY"))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        ])
      ]))
    : _createCommentVNode("", true)
}